import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import {
  COLLECTIONS_CREATE_COLLECTION_WITH_CSV_BEGIN,
  COLLECTIONS_CREATE_COLLECTION_WITH_CSV_SUCCESS,
  COLLECTIONS_CREATE_COLLECTION_WITH_CSV_FAILURE,
  COLLECTIONS_CREATE_COLLECTION_WITH_CSV_DISMISS_ERROR,
} from './constants';

export function createCollectionWithCsv(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_CREATE_COLLECTION_WITH_CSV_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/collections/createWithCsv`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: COLLECTIONS_CREATE_COLLECTION_WITH_CSV_SUCCESS,
            data: res.data,
          });
          Mixpanel.track('Created Collection', {
            uuid: res.data.uuid,
            colletionName: res.data.colletionName,
          });
          toast.success('Collection Created Successfully !');
          resolve(res);
        },
        (err) => {
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          Mixpanel.track('Failed to creat collection');
          dispatch({
            type: COLLECTIONS_CREATE_COLLECTION_WITH_CSV_FAILURE,
            data: { error: errMsg },
          });
          console.log('createWithCsv errrr', err);
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateCollectionWithCsvError() {
  return {
    type: COLLECTIONS_CREATE_COLLECTION_WITH_CSV_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_CREATE_COLLECTION_WITH_CSV_BEGIN:
      return {
        ...state,
        createCollectionWithCsvPending: true,
        createCollectionWithCsvError: null,
      };

    case COLLECTIONS_CREATE_COLLECTION_WITH_CSV_SUCCESS:
      return {
        ...state,
        createCollectionWithCsvPending: false,
        createCollectionWithCsvError: null,
        projectCollections: [...state.projectCollections, action.data],
        selectedCollection: action.data,
        items: [],
      };

    case COLLECTIONS_CREATE_COLLECTION_WITH_CSV_FAILURE:
      return {
        ...state,
        createCollectionWithCsvPending: false,
        createCollectionWithCsvError: action.data.error,
      };

    case COLLECTIONS_CREATE_COLLECTION_WITH_CSV_DISMISS_ERROR:
      return {
        ...state,
        createCollectionWithCsvError: null,
      };

    default:
      return state;
  }
}
